import { gql } from '@apollo/client';
import { BlazeError } from '@blaze-cms/core-errors';
import upperfirst from 'lodash.upperfirst';
import getDataProperties from '../../../../helpers/mappers/get-data-properties';

function buildUpdateEntityMutation(entitySchema) {
  if (!entitySchema.actions || !entitySchema.actions.update || !entitySchema.properties) {
    throw new BlazeError(
      'Update DataEntity query requires get action and properties from entity schema'
    );
  }

  const actionInput = upperfirst(`${entitySchema.actions.update}Input`);
  const dataProperties = getDataProperties(entitySchema);

  return gql`
  mutation updateEntity($input:  ${actionInput}) {
    updateEntity: ${entitySchema.actions.update}(input: $input){
        result {
          id,
          ${dataProperties.join(',\n')},
          updated
      }
    }
  }
  `;
}

export default buildUpdateEntityMutation;
